import { styled, Button as BaseButton, WithTheme } from '@material-ui/core'

const BUTTON_HEIGHT = 60
const BUTTON_MIN_WIDTH = 128

const LOGO_HEIGHT = 35

interface ButtonProps extends WithTheme {
  active?: boolean
}

export const Button = styled(BaseButton)(({ theme, active }: ButtonProps) => ({
  height: BUTTON_HEIGHT,
  fontWeight: 700,
  boxShadow: `inset 0px 0px 1px ${theme.palette.grey[300]}`,
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: theme.palette.grey[300],
  borderRadius: 8,
  minWidth: BUTTON_MIN_WIDTH,
  color: '#565758',
  backgroundColor: theme.palette.common.white,
  fontSize: 12,
  lineHeight: '23px',
  transition: '.3s',
  '&:hover': {
    boxShadow: `inset 0px 0px 1px ${theme.palette.success.dark}`,
    borderColor: theme.palette.success.dark,
    color: theme.palette.success.dark,
    backgroundColor: theme.palette.common.white,
  },
  ...(active && {
    boxShadow: `inset 0px 0px 1px ${theme.palette.success.dark}`,
    backgroundColor: theme.palette.common.white,
    borderColor: theme.palette.success.dark,
    color: theme.palette.success.dark,
  }),
}))

export const Logo = styled('img')({
  height: LOGO_HEIGHT,
  width: 'auto',
})
